module.exports = __webpack_public_path__ + "static/media/ABRIDGED STANDARD FORMULARY.d054b8a6.doc";